const initialState = {
  dealsHubProduct: {
    products: [],
    listToExport: [],
    filters: {

    }
  }
};

export default function dealsHubProducts(state = initialState, action) {
  switch (action.type) {
    case "FETCH_DEALS_HUB_PRODUCT":
      return {
        ...state,
        dealsHubProduct: { ...state.dealsHubProduct, products: action.payload }
      };

    case "FETCH_DEALS_HUB_PRODUCT_MORE":
      return {
        ...state,
        dealsHubProduct: {
          ...state.dealsHubProduct,
          products: {
            ...state.dealsHubProduct.products,
            products: [
              ...state.dealsHubProduct.products.products,
              ...action.payload.products
            ],
            is_available: action.payload.is_available
          }
        }
      };

    case "HANDLE_FILTERS_CHANGE":
      return {
        ...state,
        dealsHubProduct: {
          ...state.dealsHubProduct,
          filters: action.payload
        }
      }

    default:
      return state;
  }
}
